import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Grid, Input, InputLabel, Link, styled, } from "@mui/material";
import { usePortalFramework } from "../../PortalFramework";
import { useAuth } from "@sal/authentication.react";
import { useNavigate } from "react-router-dom";
import { LoginWithMicrosoftButton } from "../microsoftSso/LoginWithMicrosoftButton";
import { useState } from "react";
const StyledInput = styled(Input)(() => ({
    color: "inherit",
    "&:not(.Mui-disabled):hover::before": {
        borderColor: "inherit",
    },
    "&:not(.Mui-disabled):before": {
        borderColor: "inherit",
    },
    "&:not(.Mui-disabled):after": {
        borderColor: "inherit",
    },
}));
export function FormLogin({ inputLabelStyles }) {
    var _a, _b;
    const portalFramework = usePortalFramework();
    const auth = useAuth();
    const navigate = useNavigate();
    // #region PROPERTIES
    const [getUsername, setUsername] = useState("");
    const [getPassword, setPassword] = useState("");
    const [getMessage, setMessage] = useState("");
    //#endregion
    // #region EVENT HANDLERS
    const onChange = (setter) => (event) => {
        setMessage("");
        setter(event.target.value);
    };
    const form_onsubmit = (e) => {
        e.preventDefault();
        if (validateControls()) {
            const remember = false;
            auth.login(getUsername, getPassword, remember, login_callback, null);
        }
    };
    const login_callback = (response) => {
        if (response.success) {
            console.debug("Logged in, now redirecting to home page");
            navigate("/");
        }
        else {
            setMessage(response.message);
        }
    };
    //#endregion
    const validateControls = () => {
        if (getUsername.length === 0) {
            setMessage("Please enter a username.");
            return false;
        }
        if (getPassword.length === 0) {
            setMessage("Please enter a password.");
            return false;
        }
        return true;
    };
    return (_jsx("form", { onSubmit: form_onsubmit, children: _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 4, children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, direction: "column", justifyContent: "space-evenly", children: [_jsx(Grid, { item: true, children: _jsx(InputLabel, { htmlFor: "txtUsername", style: Object.assign({}, inputLabelStyles), children: "Username" }) }), _jsx(Grid, { item: true, children: _jsx(StyledInput, { fullWidth: true, type: "text", id: "txtUsername", name: "txtUsername", value: getUsername, placeholder: "Enter username", autoComplete: "off", autoCorrect: "off", spellCheck: "false", onChange: onChange(setUsername) }) })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, direction: "column", justifyContent: "space-evenly", children: [_jsx(Grid, { item: true, children: _jsx(InputLabel, { htmlFor: "txtPassword", style: Object.assign({}, inputLabelStyles), children: "Password" }) }), _jsx(Grid, { item: true, children: _jsx(StyledInput, { fullWidth: true, name: "txtPassword", id: "txtPassword", type: "password", value: getPassword, placeholder: "Enter password", autoComplete: "off", autoCorrect: "off", spellCheck: "false", onChange: onChange(setPassword) }) })] }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", color: "primary", size: "large", children: "Log in" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(Link, { variant: "body1", href: "#/ForgotPassword", sx: { color: "inherit" }, children: "Forgot password?" }) }), ((_b = (_a = portalFramework.settings) === null || _a === void 0 ? void 0 : _a.microsoftSsoSettings) === null || _b === void 0 ? void 0 : _b.enableSso) ? (_jsx(Grid, { item: true, xs: 12, children: _jsx(LoginWithMicrosoftButton, { buttonProps: {
                            fullWidth: true,
                            variant: "outlined",
                            size: "large",
                            color: "inherit",
                        }, setMessage: setMessage }) })) : (""), _jsx(Grid, { item: true, xs: 12, children: getMessage ? _jsx(Alert, { severity: "error", children: getMessage }) : null })] }) }));
}
